const state = {
    data: [],
}

const mutations = {
    SET_ARTICLES(state, param) {
        

    }
}

const actions = {
    getArticles(store, state) {
        store.commit("SET_ARTILE");
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}